/**
 * 通讯录头部副标题的两个纯函数（21ae）。
 *
 * **刻意单独成模块**：页头在外壳 pages.tsx 里（首屏块），而 contactsPageModel
 * 是通讯录懒块的东西——从那边 import 任何一个符号都会把整模块拖进首屏预算
 * （icons.tsx 文件头记过同一条坑）。这里只放首屏真的要用的两件。
 */
import type { ContactsBook } from '~/chat/contactsModel';

/** 好友册里的好友数（跨分组去重；分组本不该重复，防御一下） */
export function friendCountOf(book: ContactsBook | null): number {
  if (book === null) return 0;
  const seen = new Set<number>();
  for (const g of book.groups) for (const f of g.friends) seen.add(f.friendId);
  return seen.size;
}

/** 头部副标题「N 位好友 · M 个群聊」（旧版 desktop_contacts_pane 逐字） */
export function contactsSummaryText(friendCount: number, groupCount: number): string {
  return `${friendCount} 位好友 · ${groupCount} 个群聊`;
}
